import { render } from "./PhoneNumberList.vue?vue&type=template&id=4ba4f383&scoped=true"
import script from "./PhoneNumberList.vue?vue&type=script&lang=js"
export * from "./PhoneNumberList.vue?vue&type=script&lang=js"

import "./PhoneNumberList.vue?vue&type=style&index=0&id=4ba4f383&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba4f383"]])

export default __exports__